import "./SuperFlux.module.css";
import Header from "@/reusable_sections/Header";
import Superflux from "./sections/Superflux";
import Footer from "@/reusable_sections/Footer";
export default function SuperFluxPage() {
  return <div>
      <Header />
      <Superflux />
      <Footer />
    </div>;
}